export const messages = {
  placeholder: 'Выберите регион',
}
